// extracted by mini-css-extract-plugin
export default {"textBottomMargin":"Profile_textBottomMargin__0OMS6"};